import { API_URL, INTEGRATION_API_URL } from '../../env';
import ApiConstants from '../ApiConstants';
import connectAPI from '../connectApi';
import Api from '../apiWithStatus';

const getChildrenList = (params, token) => {
  return connectAPI(
    ApiConstants.GET_CHILDREN,
    params,
    'post',
    token,
    API_URL,
    true,
    true
  );
};

const addChildren = (params, token) => {
  return connectAPI(
    ApiConstants.ADD_CHILDREN,
    params,
    'post',
    token,
    API_URL,
    true,
    true
  );
};

const addFamilyMember = (params, token) => {
  return connectAPI(
    ApiConstants.ADD_FAMILY_MEMBER,
    params,
    'post',
    token,
    API_URL,
    true,
    true
  );
};

const addUserDetails = (params, token) => {
  return Api(
    ApiConstants.ADD_USER_DETAILS,
    params,
    'post',
    token,
    INTEGRATION_API_URL
  );
};
const checkUserDetailsSigned = (params, token) => {
  return Api(
    `${ApiConstants.CHECK_USER_DETAILS_SIGNED}/${params}`,
    null,
    'get',
    token,
    INTEGRATION_API_URL
  );
};
export { getChildrenList, addChildren, addFamilyMember,addUserDetails,checkUserDetailsSigned};
